const { getCustomerFields } = require("./apiFunctions");

async function getCustomFields(parentID, type, licenseKey) {
	try {
		let response = await getCustomerFields({ parentID, licenseKey });
		if (response.status === 200) {
			const fields = response.data.data.fields;
			const object = {
				customFields: {},
			};
			const touchedFields = {};
			fields.forEach((field) => {
				if (field.fieldType == "default") {
					field.controlType == "multi_select" ||
						field.controlType === "multi_text"
						? (object[field.key] = [])
						: field.controlType === "boolean"
							? (object[field.key] = false)
							: (object[field.key] = "");
					touchedFields[field.key] = false;
				} else {
					field.controlType == "multi_select" ||
						field.controlType === "multi_text"
						? (object["customFields"][field.key] = [])
						: field.controlType === "boolean"
							? (object["customFields"][field.key] = false)
							: (object["customFields"][field.key] = "");
					touchedFields[field.key] = false;
				}
			});
			if (type == "edit") {
				return [fields, touchedFields];
			}
			return [fields, object, touchedFields];
		} else {
			return [];
		}
	} catch (error) {
		console.log(error.message);
		return [];
	}
}

function dynamicRules(fields) {
	let rules = {
		customFields: {},
	};
	for (let key in fields) {
		if (fields[key].fieldType == "default") {
			rules[fields[key].key] = {
				required: fields[key].mandatory,
			};
		} else {
			rules["customFields"][fields[key].key] = {
				required: fields[key].mandatory,
			};
		}
	}
	return rules;
}

function columnWidth(data, isMobile) {
	if (isMobile) {
		return 12;
	}
	if (
		data == "text" ||
		data == "email" ||
		data == "single_select" ||
		data == "multi_select" ||
		data == "number" ||
		data == "boolean" ||
		data == "multi_text" ||
		data == "date" ||
		data == "location"
	) {
		return 6;
	} else if (data == "upload_file") {
		return 9;
	} else {
		return 12;
	}
}

function getPersonalInfoCol(data, isMobile) {
	if (isMobile) {
		return 12;
	}
	if (data != "textarea") {
		return 4;
	}

	return 12;
}

function showError(field, dirtyStatus, context) {
	if (dirtyStatus) {
		if (!validateField(field, context)) {
			return true;
		}
	}
	return false;
}

function validateField(field, { newObject, validations, valText, invalidPhoneFields }) {
	const value =
		field.fieldType === "default"
			? newObject[field.key]
			: newObject.customFields[field.key];
	const rules =
		field.fieldType === "default"
			? validations[field.key]
			: validations.customFields[field.key];
	const phonePattern = /^[6-9]\d{9}$/i;
	const urlPattern =
		/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
	// Check if the field is required
	const namePattern = /^[a-zA-Z ]*$/;
	if (rules && rules.required) {
		if (field.controlType === "multi_select") {
			if (!Array.isArray(value) || (value && value.length === 0)) {
				valText[field.key] = "Required";
				return false;
			}
		} else if (field.controlType === "email") {
			const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
			if (!value || (value && value.length == 0)) {
				valText[field.key] = "Required";
				return false;
			}
			if (value && value.length > 0 && !emailRegex.test(value)) {
				valText[field.key] = "Invalid email";
				return false;
			}
			if (field.limit && value && value.length > field.limit) {
				valText[field.key] = "Max Char Exceeded";
				return false;
			}
		} else if (field.controlType === "single_select") {
			if (Array.isArray(field.values) && field.values.length > 0) {
				const hasDefault = field.values.some((opt) => opt.isDefault);
				if (!hasDefault && !value) {
					valText[field.key] = "Required";
					return false;
				}
			} else if (!value) {
				valText[field.key] = "Required";
				return false;
			}
		} else if (field.controlType === "upload_file") {
			if (value instanceof File) {
				if (!value || value.name.length === 0) {
					valText[field.key] = "Required";
					return false;
				}
			} else {
				if (!value || value.length === 0 || Object.keys(value).length === 0) {
					valText[field.key] = "Required";
					return false;
				}
			}
		} else if (field.controlType == "multi_text") {
			if (value.length == 0) {
				valText[field.key] = "Required";
				return false;
			}
			// if (field.limit && value && value.length > field.limit) {
			// 	valText[field.key] = "Max Char Exceeded";
			// 	return false;
			// }

			if (field.limit && field && value.length > 0) {
				for (let i = 0; i < value.length; i++) {
					if (value[i].length > field.limit) {
						valText[field.key] = `Max Char Exceeded ${field.limit}`;
						return false;
					}
				}
			}
			return !value ||
				(value && value.length > 0 && value.every((val) => val === ""))
				? false
				: true;
		} else if (field.controlType == "rich_text_box") {
			if (value.length === 0) {
				valText[field.key] = "Required";
				return false;
			} else {
				let plainText = value.replace(/<[^>]+>/g, ""); // Remove HTML tags
				plainText = plainText.replace(/&nbsp;/g, " "); // Replace &nbsp; with regular spaces
				plainText = plainText.trim(); // Trim leading and trailing whitespace
				if (!plainText.length) {
					valText[field.key] = "Required";
					return false;
				} else if (field.limit && plainText.length > field.limit) {
					valText[field.key] = "Max Char Exceeded";
					return false;
				}
			}
		} else if (field.controlType == "date") {
			if (!value) {
				valText[field.key] = "Required";
				return false;
			} else {
				if (field.key == "yearOfPassout" && newObject["yearOfJoining"]) {
					const startDate = new Date(newObject["yearOfJoining"]);
					const endDate = new Date(newObject["yearOfPassout"]);
					if (endDate < startDate) {
						valText[field.key] = "End Date cannot be before start date";
						return false;
					}
				} else if (field.key == "endDate" && newObject["startDate"]) {
					const startDate = new Date(newObject["startDate"]);
					const endDate = new Date(newObject["endDate"]);
					if (endDate < startDate) {
						valText[field.key] = "End Date cannot be before start date";
						return false;
					}
				}
			}
		} else {
			if ((field.key == "firstName" && value && value.length > 0) || (field.key == "lastName" && value && value.length > 0)) {
				if (!namePattern.test(value)) {
					valText[field.key] = "Invalid name";
					return false;
				} else if (field.limit && value && value.length > field.limit) {
					valText[field.key] = "Max Char Exceeded";
					return false;
				}
			}
			// Check if the value is empty or exceeds the character limit
			else if (!value && field.key != "totalYearsOfExp") {
				valText[field.key] = "Required";
				return false;
			} else if (field.key == "highlight" || field.key === "responsibility") {
				if (field.limit && field && value.length > 0) {
					for (let i = 0; i < value.length; i++) {
						if (value[i].length > field.limit) {
							valText[field.key] = "Max Char Exceeded";
							return false;
						}
					}
				}
				return !value ||
					(value && value.length > 0 && value.every((val) => val === ""))
					? false
					: true;
			} else if (field.limit && value && value.length > field.limit) {
				valText[field.key] = "Max Char Exceeded";
				return false;
			} else if (field.key == "phoneNumber" || field.key == "altPhoneNumber") {
				if (invalidPhoneFields && invalidPhoneFields[field.key]) {
					valText[field.key] = "Enter Valid Phone Number";
					return false;
				}

				const countryCodeVal = field.key === "phoneNumber"
					? (newObject["countryCode"] || "+91").toString().replace(/[\s+]/g, "")
					: (newObject["altCountryCode"] || "+91").toString().replace(/[\s+]/g, "");

				if (countryCodeVal === "91") {
					if (value.length !== 10 || !phonePattern.test(value)) {
						valText[field.key] = "Enter Valid Phone Number";
						return false;
					}
				}
			} else if (field.key === "openingsCount" && value == 0) {
				valText[field.key] = "Openings Count should be more than 0";
				return false;
			} else if (field.key == "workingTime") {
				if (value > 24) {
					valText[field.key] = "Working hours should not be greater than 24";
					return false;
				}
			} else if (field.key == "experince") {
				if (value > 99) {
					valText[field.key] = "Experience should not be greater than 99";
					return false;
				}
			} else if (field.key == "totalYearsOfExp") {
				if (
					!/^(?:\d{1,2}(?:\.\d{0,2})?)?$/.test(value) ||
					value < 0 ||
					value > 99
				) {
					valText[field.key] = "Invalid Experience";
					return false;
				}
				if (value === "" || value === null) {
					valText[field.key] = "Required";
					return false;
				}
			}
		}
	} else {
		if (field.controlType === "email" && value && value.length > 0) {
			const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
			if (!emailRegex.test(value)) {
				valText[field.key] = "Invalid email";
				return false;
			}
			if (field.limit && value && value.length > field.limit) {
				valText[field.key] = "Max Char Exceeded";
				return false;
			}
		} else if (field.key == "workingTime") {
			if (value > 24) {
				valText[field.key] = "Working hours should not be greater than 24";
				return false;
			}
		} else if (field.key == "experince") {
			if (value > 99) {
				valText[field.key] = "Experience should not be greater than 99";
				return false;
			}
		} else if (field.key == "highlight") {
			if (field.limit && field && value.length > 0) {
				for (let i = 0; i < value.length; i++) {
					if (value[i].length > field.limit) {
						valText[field.key] = "Max Char Exceeded";
						return false;
					}
				}
			}
		} else if (field.key == "altPhoneNumber" && value) {
			if (field.limit && value.length > field.limit) {
				valText[field.key] = "Max Char Exceeded";
				return false;
			}
			else if (invalidPhoneFields && invalidPhoneFields[field.key]) {
				valText[field.key] = "Enter Valid Phone Number";
				return false;
			}
			const altCountryCodeVal = (newObject["altCountryCode"] || "+91")
				.toString()
				.replace(/[\s+]/g, "");
			if (altCountryCodeVal === "91") {
				if (value.length !== 10 || !phonePattern.test(value)) {
					valText[field.key] = "Enter Valid Phone Number";
					return false;
				}
			}
		} else if (field.key == "portfolio") {
			if (value.length > 0 && valText[field.key] != "") {
				for (let i = 0; i < value.length; i++) {
					if (!urlPattern.test(value[i]) && value[i].length > 0) {
						valText[field.key] = "Enter Valid Link";
						return false;
					}
					// break;
				}
			}
			if (field.limit && field && value.length > 0) {
				for (let i = 0; i < value.length; i++) {
					if (value[i].length > field.limit) {
						valText[field.key] = "Max Char Exceeded";
						return false;
					}
				}
			}
		} else if (field.key == "totalYearsOfExp") {
			if (
				(!/^(?:\d{1,2}(?:\.\d{0,2})?)?$/.test(value) ||
					value < 0 ||
					value > 99) &&
				value != null
			) {
				valText[field.key] = "Invalid Experience";
				return false;
			}
			// if (value === "" || value === null) {
			// 	valText[field.key] = "Required";
			// 	return false;
			// }
		} else if (field.key == "usedSkills") {
			if (field && value.length > 0) {
				for (let i = 0; i < value.length; i++) {
					if (value[i].length > 64) {
						valText[field.key] = `Max Char Exceeded 64`;
						return false;
					}
				}
			}
		} else if ((field.key == "firstName" && value && value.length > 0) || (field.key == "lastName" && value && value.length > 0)) {
			if (!namePattern.test(value)) {
				valText[field.key] = "Invalid name";
				return false;
			}
		}
		else if (field.limit && value && value.length > field.limit) {
			valText[field.key] = "Max Char Exceeded";
			return false;
		}
	}
	return true;
}

function checkFieldKeys(field, viewObject) {
	let fieldKey;
	if (field.fieldType == "default") {
		if (
			viewObject[field.key] == "" ||
			viewObject[field.key] == undefined ||
			viewObject[field.key] == null ||
			viewObject[field.key].length == 0
		) {
			fieldKey = true;
		} else {
			fieldKey = false;
		}
	} else {
		if (
			viewObject.customFields[field.key] === "" ||
			viewObject.customFields[field.key] === undefined ||
			viewObject.customFields[field.key] == null ||
			viewObject.customFields[field.key].length == 0
		) {
			fieldKey = true;
		} else {
			fieldKey = false;
		}
	}
	return fieldKey;
}
function isHtmlContent(field, viewObject) {
	const customField =
		field.fieldType == "default"
			? viewObject[field.key]
			: viewObject.customFields[field.key];
	if (
		(field.controlType == "rich_text_box" &&
			typeof viewObject[field.key] === "string" &&
			viewObject[field.key] !== "") ||
		(field.controlType == "rich_text_box" &&
			typeof customField === "string" &&
			customField !== "")
	) {
		return true;
	} else {
		return false;
	}
}
function checkValuesOfKey(field, viewObject) {
	let fieldValue;
	if (field.fieldType === "default") {
		if (
			field.controlType == "multi_select" &&
			Array.isArray(viewObject[field.key])
		) {
			let usernameArray = viewObject[field.key].map((obj) => obj.username);
			fieldValue = usernameArray.join(", ");
		} else if (
			field.controlType == "single_select" &&
			typeof viewObject[field.key] === "string" &&
			viewObject[field.key] !== ""
		) {
			let val;
			field.values.forEach((value) => {
				val = value.label;
			});
			fieldValue = val;
		} else if (
			field.controlType == "upload_file" &&
			typeof viewObject[field.key] === "string" &&
			viewObject[field.key] !== ""
		) {
			let lastIndex = viewObject[field.key].lastIndexOf("/");
			fieldValue = viewObject[field.key].substring(lastIndex + 1);
		} else if (
			field.controlType == "multi_text" &&
			Array.isArray(viewObject[field.key])
		) {
			fieldValue = viewObject[field.key].join(", ");
		} else if (field.controlType == "boolean") {
			fieldValue =
				viewObject[field.key] == "" ||
					viewObject[field.key] == null ||
					viewObject[field.key] == false
					? "No"
					: "Yes";
		} else {
			fieldValue = viewObject[field.key];
		}
	} else {
		const customField = viewObject.customFields[field.key];
		if (field.controlType == "multi_select" && Array.isArray(customField)) {
			const fieldValues = [];
			field.values.forEach((val) => {
				customField.forEach((key) => {
					if (val.key === key) {
						fieldValues.push(val.label);
					}
				});
			});
			fieldValue = fieldValues.join(", ");
		} else if (
			field.controlType == "single_select" &&
			typeof customField === "string" &&
			customField !== ""
		) {
			let val;
			field.values.forEach((value) => {
				if (value.key === customField) {
					val = value.label;
				}
			});
			fieldValue = val;
		} else if (
			field.controlType == "upload_file" &&
			typeof customField === "string" &&
			customField !== ""
		) {
			let lastIndex = customField.lastIndexOf("/");
			fieldValue = customField.substring(lastIndex + 1);
		} else if (
			field.controlType === "multi_text" &&
			Array.isArray(customField)
		) {
			fieldValue = customField.join(", ");
		} else if (field.controlType == "boolean") {
			fieldValue =
				customField == "" || customField == null || customField == false
					? "No"
					: "Yes";
		} else {
			fieldValue = customField;
		}
	}

	return fieldValue;
}

module.exports = {
	getCustomFields,
	dynamicRules,
	columnWidth,
	showError,
	validateField,
	checkFieldKeys,
	isHtmlContent,
	checkValuesOfKey,
	getPersonalInfoCol,
};
